import React, { Component } from 'react';
import {connect} from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { withNavigation, withTranslate } from '../../../core/TenantProvider';
import ReferralSent from '../../../containers/ReferContainer/ReferralSent';
import { actions as RegisterActions } from '../../../redux/modules/register';
import { TriggerGoogleAnalytics4Tag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

interface APRegistrationSuccessProps {
    translate: Function,
    navigate: any,
    updateRegisterCustomerStatus: Function,
    showReferralMessage?: boolean
}

class APRegistrationSuccess extends Component<APRegistrationSuccessProps, {}> {

    onReturnHandler = () => {
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            GoogleAnalytics4Tags.eventAction.click,
            GoogleAnalytics4Tags.registerClient.click.clientRegistrationCompleteNewCustomerCta
        );

        this.props.navigate('/register_client');
        this.props.updateRegisterCustomerStatus();
    }

    componentDidMount() {
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            GoogleAnalytics4Tags.eventAction.load,
            GoogleAnalytics4Tags.registerClient.load.clientRegistrationCompletePageLoad
        );
    }

    render() {
        const {
            translate,
            showReferralMessage,
        } = this.props;

        return (
            <>
            {showReferralMessage ?
                    <ReferralSent
                        referralLink={translate('register.customer.skip.proof.message.link')}
                        secondaryButtonText={translate('register.customer.confirmation.secondary.button')}
                        redirectButtontext={translate('register.customer.confirmation.redirect.button')}
                        onReturn={this.onReturnHandler} /> :
                    <ReferralSent
                        redirectButtontext={translate('register.customer.confirmation.redirect.button')}
                        secondaryButtonText={translate('register.customer.confirmation.secondary.button')}
                        onReturn={this.onReturnHandler} />}
            </>
        )
    }
}


const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    updateRegisterCustomerStatus: RegisterActions.updateRegisterCustomerStatus,
}, dispatch);

export default withNavigation(withTranslate(connect(null, mapDispatchToProps)(APRegistrationSuccess)));